// extracted by mini-css-extract-plugin
export default {"CardBaseWithSash":"card-base-with-sash-module__CardBaseWithSash--C3yM9"};